<template>
	<div>
		<v-btn
			color="blue-grey"
			class="ma-0 white--text"
			block
			tile
			@click="$emit('cerrar')"
		>
			Cerrar
			<v-icon right>
				mdi-arrow-collapse-right
			</v-icon>
		</v-btn>
		<h3 class="pa-2">Configuración de sección</h3>
		<v-expansion-panels accordion>
			<v-expansion-panel>
				<v-expansion-panel-header>Espaciado</v-expansion-panel-header>
				<v-expansion-panel-content>
					<v-select label="Ancho máximo del contenido" :items="anchura.opciones" v-model="anchura.valor"></v-select>

					<div>
						<v-subheader class="pa-0">Espaciado a la izquierda y a la derecha</v-subheader>
						<v-slider
							v-model="espaciado.horizontal.valor"
							class="mt-4"
							thumb-label="always"
							:thumb-size="24"
							:step="1"
							:max="10"
							ticks
							:tick-size="5"
						></v-slider>
					</div>

					<div>
						<v-subheader class="pa-0">Espaciado arriba y abajo</v-subheader>
						<v-slider
							v-model="espaciado.vertical.valor"
							class="mt-4"
							thumb-label="always"
							:thumb-size="24"
							:step="1"
							:max="10"
							ticks
							:tick-size="5"
						></v-slider>
					</div>

					<div>
						<v-subheader class="pa-0">Espaciado en medio de las columnas</v-subheader>
						<v-slider
							v-model="espaciado.intermedio.valor"
							class="mt-4"
							thumb-label="always"
							:thumb-size="24"
							:step="1"
							:min="0"
							:max="5"
							ticks
							:tick-size="5"
						></v-slider>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
			<v-expansion-panel>
				<v-expansion-panel-header>Fondo</v-expansion-panel-header>
				<v-expansion-panel-content>
					<v-subheader class="pa-0">Fondo de la sección</v-subheader>
					<v-radio-group
						v-model="fondo.tipo"
						class="mt-1"
						row
					>
						<v-radio
							label="Ninguno"
							value="ninguno"
						></v-radio>
						<v-radio
							label="Color"
							value="color"
						></v-radio>
						<v-radio
							label="Imagen"
							value="imagen"
						></v-radio>
					</v-radio-group>
					<v-color-picker
						v-if="fondo.tipo === 'color'"
						v-model="fondo.color"
						dot-size="25"
						canvas-height="80"
						mode="hexa"
					></v-color-picker>
					<div
						v-if="fondo.tipo === 'imagen'"
						style="max-width: 500px; max-height: 500px;"
					>
						<div v-if="fondo.imagen.ubicación">
							<v-img :src="fondo.imagen.ubicación" height="100px"></v-img>
							<v-btn @click="fondo.seleccionandoImagen = true">Cambiar imagen</v-btn>
						</div>
						<v-btn v-else @click="fondo.seleccionandoImagen = true">Seleccionar imagen</v-btn>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
			<v-expansion-panel>
				<v-expansion-panel-header>Texto</v-expansion-panel-header>
				<v-expansion-panel-content>
					<div>
						<v-subheader class="pa-0">Color de texto e íconos</v-subheader>
						<v-radio-group
							v-model="texto.color.personalizado"
							class="mt-1"
							row
						>
							<v-radio
								label="Predeterminado"
								:value="false"
							></v-radio>
							<v-radio
								label="Personalizado"
								:value="true"
							></v-radio>
						</v-radio-group>
						<v-color-picker
							v-if="texto.color.personalizado"
							v-model="texto.color.valor"
							dot-size="25"
							canvas-height="80"
							mode="hexa"
						></v-color-picker>
					</div>

					<div>
						<v-subheader class="pa-0">Espaciado entre títulos y párrafos</v-subheader>
						<v-radio-group
							v-model="texto.espaciado.personalizado"
							class="mt-1"
							row
						>
							<v-radio
								label="Predeterminado"
								:value="false"
							></v-radio>
							<v-radio
								label="Personalizado"
								:value="true"
							></v-radio>
						</v-radio-group>
						<v-slider
							v-if="texto.espaciado.personalizado"
							v-model="texto.espaciado.valor"
							class="mt-4"
							thumb-label="always"
							:thumb-size="24"
							:step="1"
							:min="1"
							:max="10"
							ticks
							:tick-size="5"
						></v-slider>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
			<v-expansion-panel
				v-if="medios.tipo === 'imagen' || medios.tipo === 'ícono'"
			>
				<v-expansion-panel-header>Medios</v-expansion-panel-header>
				<v-expansion-panel-content>
					<div>
						<v-subheader class="pa-0">Tipo de medio</v-subheader>
						<v-radio-group
							v-model="medios.tipo"
							class="mt-1"
							row
						>
							<v-radio
								label="Imágenes"
								value="imagen"
							></v-radio>
							<v-radio
								label="Íconos"
								value="ícono"
							></v-radio>
						</v-radio-group>
					</div>

					<div>
						<v-subheader class="pa-0">Tamaño</v-subheader>
						<v-slider
							v-model="medios.tamaño"
							class="mt-4"
							thumb-label="always"
							:thumb-size="24"
							:step="20"
							:min="100"
							:max="600"
							ticks
							:tick-size="5"
						></v-slider>
					</div>

					<div>
						<v-subheader class="pa-0">Aspecto</v-subheader>
						<v-radio-group
							v-model="medios.aspecto"
							class="mt-1"
							row
						>
							<v-radio
								label="Proporcionalmente ancha"
								value=""
							></v-radio>
							<v-radio
								label="Cuadrada"
								value="cuadrada"
							></v-radio>
							<v-radio
								label="Redonda"
								value="redonda"
							></v-radio>
						</v-radio-group>
					</div>

					<div v-if="medios.tipo === 'imagen'">
						<v-subheader class="pa-0">Ampliar o contener imagen</v-subheader>
						<v-radio-group
							v-model="medios.contenida"
							class="mt-1"
						>
							<v-radio
								label="Ampliar y rellenar espacio"
								:value="false"
							></v-radio>
							<v-radio
								label="Mantener contenida"
								:value="true"
							></v-radio>
						</v-radio-group>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</div>
</template>


<script>

export default {
  name: 'SeccionConfigurar',

  data: () => ({

		fondo: {
			tipo: '',
			color: '#DCDCDCFF',
			imagen: {
				tipo: 'imagen',
				ubicación: ''
			},
			seleccionandoImagen: false,
		},

		texto: {
			color: {
				personalizado: false,
				valor: ''
			},
			espaciado: {
				personalizado: false,
				valor: 2
			}
		},

		espaciado: {
			horizontal: {
				valor: 0,
			},
			vertical: {
				valor: 0,
			},
			intermedio: {
				valor: 0,
			}
		},

		anchura: {
			valor: '',
			opciones: [
				{ 'text': '600 pixeles', 'value': 'anchura-600px' },
				{ 'text': '700 pixeles', 'value': 'anchura-700px' },
				{ 'text': '800 pixeles', 'value': 'anchura-800px' },
				{ 'text': '1000 pixeles', 'value': 'anchura-1000px' },
				{ 'text': '1200 pixeles', 'value': 'anchura-1200px' },
				{ 'text': '1400 pixeles', 'value': 'anchura-1400px' },
				{ 'text': 'Todo el ancho del contenido principal de la página', 'value': '' }
			],
		},

		medios: {
			tipo: '',
			tamaño: 200,
			aspecto: '',
			contenida: false,
		},

	}),

	props: {
		value: {
			type: Object
		}
	},

	watch: {
		'fondo.tipo': function() {
			this.aplicarFondo()
		},
		'fondo.color': function() {
			this.aplicarFondo()
		},
		'fondo.imagen.ubicación': function() {
			this.aplicarFondo()
		},
		'texto.color.personalizado': function() {
			this.aplicarTextoColor()
		},
		'texto.color.valor': function() {
			this.aplicarTextoColor()
		},
		'texto.espaciado.personalizado': function() {
			this.aplicarTextoEspaciado()
		},
		'texto.espaciado.valor': function() {
			this.aplicarTextoEspaciado()
		},
		'espaciado.horizontal.valor': function(v) {
			this.eliminarClasesQueEmpiezanPor('espaciado-horizontal-')
			if (v > 0 && v <= 10) {
				this.aplicarClase(`espaciado-horizontal-${v}`)
			}
		},
		'espaciado.vertical.valor': function(v) {
			this.eliminarClasesQueEmpiezanPor('espaciado-vertical-')
			if (v > 0 && v <= 10) {
				this.aplicarClase(`espaciado-vertical-${v}`)
			}
		},
		'espaciado.intermedio.valor': function(v) {
			this.eliminarClasesQueEmpiezanPor('espaciado-intermedio-')
			if (v > 0 && v <= 5) {
				this.aplicarClase(`espaciado-intermedio-${v}`)
			}
		},
		'anchura.valor': function(clase) {
			this.eliminarClasesQueEmpiezanPor('anchura-')
			this.aplicarClase(clase)
		},
		'medios.tipo': function() {
			this.aplicarMediosTipo()
		},
		'medios.tamaño': function() {
			this.aplicarMediosTamaño()
		},
		'medios.aspecto': function() {
			this.aplicarMediosAspecto()
		},
		'medios.contenida': function() {
			this.aplicarMediosContenida()
		},
		'value': function(v) {
			this.restablecer()

			if (!v) {
				return
			}

			if (this.value.estilos['background-color']) {
				this.fondo.tipo = 'color'
				this.fondo.color = this.value.estilos['background-color']
			} else if (this.value.estilos['background-image']) {
				this.fondo.tipo = 'imagen'
				this.fondo.imagen.ubicación = this.value.estilos['background-image'].replace(/^url\(/, '').replace(/\)$/, '')
			} else {
				this.fondo.tipo = 'ninguno'
			}

			if (this.value.estilos['color']) {
				this.texto.color.personalizado = true
				this.texto.color.valor = this.value.estilos['color']
			}

			let numEspaciado = function(clase, rplzr) {
				let v = 0
				try {
					v = Number(clase.replace(rplzr, ''))
					v < 0 ? 0 : v > 10 ? 10 : v
				} catch (e) {
					console.error('[75230384]', e)
					window.alert('¡Advertencia! Ocurrió un error inesperado. Por favor comuníquese con el administrador y proporciónele este número de error: 75230384.')
				}

				return v
			}

			for (let clase in this.value.clases) {
				if (clase.indexOf('espaciado-horizontal-') === 0) {
					this.espaciado.horizontal.valor = numEspaciado(clase, 'espaciado-horizontal-')
					break
				}
			}

			for (let clase in this.value.clases) {
				if (clase.indexOf('espaciado-vertical-') === 0) {
					this.espaciado.vertical.valor = numEspaciado(clase, 'espaciado-vertical-')
					break
				}
			}

			for (let clase in this.value.clases) {
				if (clase.indexOf('espaciado-intermedio-') === 0) {
					this.espaciado.intermedio.valor = numEspaciado(clase, 'espaciado-intermedio-')
					break
				}
			}

			if (this.value.clases['anchura-600px']) {
				this.anchura.valor = 'anchura-600px'
			} else if (this.value.clases['anchura-700px']) {
				this.anchura.valor = 'anchura-700px'
			} else if (this.value.clases['anchura-800px']) {
				this.anchura.valor = 'anchura-800px'
			} else if (this.value.clases['anchura-1000px']) {
				this.anchura.valor = 'anchura-1000px'
			} else if (this.value.clases['anchura-1200px']) {
				this.anchura.valor = 'anchura-1200px'
			} else if (this.value.clases['anchura-1400px']) {
				this.anchura.valor = 'anchura-1400px'
			}

			for (let c of this.value.columnas) {
				for (let p of c.partes) {
					if (p.tipo === 'ícono') {
						this.medios.tipo = 'ícono'
					} else if (p.tipo === 'imagen') {
						this.medios.tipo = 'imagen'
						this.medios.contenida = !!p.clases.contenida
					} else if (p.tipo === 'texto') {
						for (let clase in p.clases) {
							if (clase.indexOf('espaciado-') === 0) {
								this.texto.espaciado.personalizado = true
								this.texto.espaciado.valor = numEspaciado(clase, 'espaciado-')
							}
						}
					}
				}
			}

			for (let c of this.value.columnas) {
				for (let p of c.partes) {
					if (p.tipo === 'imagen' || p.tipo === 'ícono') {
						let cls = 0
						for (let clase in p.clases) {
							if (clase.indexOf('tamaño-') === 0) {
								try {
									cls = Number(clase.replace('tamaño-', '').replace('px', ''))
								} catch (e) {
									console.error('[75328042]', e)
									window.alert('¡Advertencia! Ocurrió un error inesperado. Por favor comuníquese con el administrador y proporciónele este número de error: 75328042.')
								}
								break
							}
						}
						this.medios.tamaño = cls < 100 || cls > 600 ? 200 : cls
						this.aplicarMediosTamaño()
					}
				}
			}
		}
	},

	methods: {
		aplicarMediosTipo: function() {
			if (!this.value) {
				return
			}

			for (let c of this.value.columnas) {
				for (let p of c.partes) {
					if (this.medios.tipo === 'ícono' && p.tipo === 'imagen') {
						this.$set(p, 'tipo', 'ícono')
						if (!p.ícono) {
							this.$set(p, 'ícono', { estilo: '', identificador: '' })
						}
					} else if (this.medios.tipo === 'imagen' && p.tipo === 'ícono') {
						this.$set(p, 'tipo', 'imagen')
					}
				}
			}
		},
		aplicarMediosTamaño: function() {
			if (!this.value) {
				return
			}

			if (this.medios.tamaño < 100 || this.medios.tamaño > 600) {
				return
			}

			for (let c of this.value.columnas) {
				for (let p of c.partes) {
					if (p.tipo === 'imagen' || p.tipo === 'ícono') {
						for (let clase in p.clases) {
							if (clase.indexOf('tamaño-') === 0) {
								this.$delete(p.clases, clase)
							}
						}
						this.$set(p.clases, `tamaño-${this.medios.tamaño}px`, true)
					}
				}
			}
		},
		aplicarMediosAspecto: function() {
			if (!this.value) {
				return
			}

			for (let c of this.value.columnas) {
				for (let p of c.partes) {
					if (p.tipo === 'imagen' || p.tipo === 'ícono') {
						if (this.medios.aspecto === 'cuadrada') {
							this.$set(p.clases, 'cuadrada', true)
							this.$delete(p.clases, 'redonda')
						} else if (this.medios.aspecto === 'redonda') {
							this.$set(p.clases, 'redonda', true)
							this.$delete(p.clases, 'cuadrada')
						} else {
							this.$delete(p.clases, 'cuadrada')
							this.$delete(p.clases, 'redonda')
						}
					}
				}
			}
		},
		aplicarMediosContenida: function() {
			if (!this.value) {
				return
			}

			for (let c of this.value.columnas) {
				for (let p of c.partes) {
					if (p.tipo === 'imagen') {
						this.$set(p.clases, 'contenida', this.medios.contenida)
					}
				}
			}
		},
		aplicarFondo: function() {
			this.fondo.seleccionandoImagen = false

			if (!this.value) {
				return
			}

			if (this.fondo.tipo === 'color' && this.fondo.color) {
				this.$set(this.value.estilos, 'background-color', this.fondo.color)
				this.$delete(this.value.estilos, 'background-image')
				this.$delete(this.value.estilos, 'background-position')
				this.$delete(this.value.estilos, 'background-size')
			} else if (this.fondo.tipo === 'imagen' && this.fondo.imagen.ubicación) {
				this.$delete(this.value.estilos, 'background-color')
				this.$set(this.value.estilos, 'background-image', `url(${this.fondo.imagen.ubicación})`)
				this.$set(this.value.estilos, 'background-position', 'center')
				this.$set(this.value.estilos, 'background-size', 'cover')
			} else {
				this.$delete(this.value.estilos, 'background-color')
				this.$delete(this.value.estilos, 'background-image')
				this.$delete(this.value.estilos, 'background-position')
				this.$delete(this.value.estilos, 'background-size')
			}
		},
		aplicarTextoColor: function() {
			if (!this.value) {
				return
			}

			if (this.texto.color.personalizado && this.texto.color.valor) {
				this.$set(this.value.estilos, 'color', this.texto.color.valor)
			} else {
				this.$delete(this.value.estilos, 'color')
			}
		},
		aplicarTextoEspaciado: function() {
			if (!this.value) {
				return
			}

			for (let c of this.value.columnas) {
				for (let p of c.partes) {
					if (p.tipo === 'texto') {
						for (let clase in p.clases) {
							if (clase.indexOf('espaciado-') === 0) {
								this.$delete(p.clases, clase)
							}
						}
						if (this.texto.espaciado.personalizado && this.texto.espaciado.valor > 0) {
							this.$set(p.clases, `espaciado-${this.texto.espaciado.valor}`, true)
						}
					}
				}
			}
		},
		eliminarClasesQueEmpiezanPor: function(empiezaPor) {
			if (!this.value) {
				return
			}

			for (let clase in this.value.clases) {
				if (clase.indexOf(empiezaPor) === 0) {
					this.$delete(this.value.clases, clase)
				}
			}
		},
		aplicarClase: function(clase) {
			if (!this.value) {
				return
			}

			this.$set(this.value.clases, clase, true)
		},
		restablecer: function() {
			this.fondo.tipo = ''
			this.fondo.color = '#DCDCDCFF'
			this.fondo.imagen.tipo = 'imagen'
			this.fondo.imagen.ubicación = ''
			this.fondo.seleccionandoImagen = false

			this.texto.color.personalizado = false
			this.texto.color.valor = ''
			this.texto.espaciado.personalizado = false
			this.texto.espaciado.valor = 2

			this.espaciado.horizontal.valor = 0
			this.espaciado.vertical.valor = 0
			this.espaciado.intermedio.valor = 0

			this.anchura.valor = ''

			this.medios.tipo = ''
			this.medios.tamaño = 200
			this.medios.aspecto = ''
			this.medios.contenida = false
		}
	}
};

</script>
